module.exports = __webpack_public_path__ + "fonts/Heebo-Bold.ede6fdf4.ttf";